import { FC } from "react"
import GoogleIcon from "@/assets/google.svg"
import OutlookIcon from "@/assets/outlook.svg"
import type { ProviderBucket } from "@/types/entities/master-list"

export const PROVIDER_BUCKET_LABELS: Record<ProviderBucket, string> = {
  google: "Google",
  microsoft: "Microsoft",
  other: "Other",
  unknown: "Unknown",
}

type Props = {
  provider?: ProviderBucket
  className?: string
}

const ProviderBadge: FC<Props> = ({ provider = "unknown", className }) => {
  const label =
    PROVIDER_BUCKET_LABELS[provider] ?? PROVIDER_BUCKET_LABELS.unknown
  return (
    <div className={`flex gap-2 items-center ${className ?? ""}`}>
      {provider === "google" ? (
        <GoogleIcon className="w-4 h-4" />
      ) : provider === "microsoft" ? (
        <OutlookIcon className="w-4 h-4" />
      ) : null}
      <span className="text-sm leading-6">{label}</span>
    </div>
  )
}

export default ProviderBadge
